import { useContext } from 'react'
import { Link as RouterLink } from 'react-router'
import { ArrowDropDown, ArrowRight } from '@mui/icons-material'
import { Grid, IconButton, Link, Tooltip, Typography, useTheme } from '@mui/material'

import { AppContext } from '../../../../providers/app-provider'
import useSharedStyles from '../../../../utils/shared.styles'
import AccountsContext from '../../context'
import useStyles from '../../index.styles'

interface IProps {
  item: number
  isOpen: boolean
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  depth: number
}

const LinkRow = (props: IProps) => {
  const { item, isOpen, setIsOpen, depth } = props

  const classes = useStyles
  const sharedClasses = useSharedStyles
  const theme = useTheme()
  const { folder, folderTree, isParticipantView } = useContext(AccountsContext)
  const { tenantId } = useContext(AppContext)
  const { name } = folderTree?.[item] ? folderTree[item] : { name: '' }
  const shouldShowParticipantView = isParticipantView || folder?.type === 'Participant'

  return (
    <Grid
      container={true}
      sx={{
        alignItems: 'flex-start',
        paddingLeft: 3 * depth + 1,
      }}
    >
      <Grid sx={classes.linkRowNameContainer}>
        {folderTree?.[item]?.children && (
          <IconButton onClick={() => setIsOpen(!isOpen)} sx={classes.linkRowIconButton} aria-label={isOpen ? `Collapse ${name}` : `Expand ${name}`}>
            {isOpen ? <ArrowDropDown fontSize="small" /> : <ArrowRight fontSize="small" />}
          </IconButton>
        )}
        <Tooltip
          title={
            <>
              {name}
              <br />
              {shouldShowParticipantView && folderTree && folderTree[item] && folderTree[item].data?.accountNumber && (
                <>Acct #{folderTree[item].data?.accountNumber}</>
              )}
            </>
          }
        >
          <div style={sharedClasses.fullWidth}>
            <Link
              component={RouterLink}
              to={`/tenant/${tenantId}/accounts/${item}`}
              variant="body1"
              underline="hover"
              aria-label={`View ${name}`}
              className="fs-exclude"
              sx={{ ...sharedClasses.overflowText, display: 'block' }}
            >
              {name}
            </Link>
            {shouldShowParticipantView && folderTree && folderTree[item] && folderTree[item].data?.accountNumber && (
              <Typography variant="body2" className="fs-exclude" sx={{ ...classes.linkRowAccountNumber(theme), ...sharedClasses.overflowText }}>
                Acct #{folderTree[item].data?.accountNumber}
              </Typography>
            )}
          </div>
        </Tooltip>
      </Grid>
    </Grid>
  )
}

export default LinkRow
